import { render, staticRenderFns } from "./UnitProgramAllocation.vue?vue&type=template&id=3e79a7d4"
import script from "./UnitProgramAllocation.vue?vue&type=script&lang=js"
export * from "./UnitProgramAllocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports